export default { sha: '89fdf60a467e3d3e18b2afe87fc4b3de3eed35e7', buildNumber: 'undefined' }
